import { render, staticRenderFns } from "./organisation-data.vue?vue&type=template&id=f3677940"
import script from "./organisation-data.vue?vue&type=script&lang=js"
export * from "./organisation-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports